export const SEARCH_CODE_PORTAL = "SEARCH_CODE_PORTAL";
export const SEARCH_CODE_PORTAL_FAIL = "SEARCH_CODE_PORTAL_FAIL";
export const SEARCH_CODE_PORTAL_SUCCESS = "SEARCH_CODE_PORTAL_SUCCESS";

export const GET_SEARCH_RESULT = "GET_SEARCH_RESULT";
export const GET_SEARCH_RESULT_SUCCESS = "GET_SEARCH_RESULT_SUCCESS";
export const GET_SEARCH_RESULT_FAIL = "GET_SEARCH_RESULT_FAIL"

export const GET_CAPCHA = "GET_CAPCHA";
export const GET_CAPCHA_SUCCESS = "GET_CAPCHA_SUCCESS";
export const GET_CAPCHA_FAIL = "GET_CAPCHA_FAIL";

export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAIL = "DOWNLOAD_FILE_FAIL";

export const RESET_TYPE_DOWNLOAD = "RESET_TYPE_DOWNLOAD";